import { useAlertStore } from '~/stores/alert'

/**
 * Check if an event invite token is still valid for registration
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.includes('/invite/event/')) return

  const email = to.query.email as string
  const token = to.params.token as string

  if (!email || !token) return

  const config = useRuntimeConfig()
  const alertStore = useAlertStore()

  try {
    const result: any = await $fetch(`${config.public.apiBase}/auth/check-event-invite/${encodeURIComponent(email)}/${token}`)

    if (!result.valid) {
      if (result.reason === 'already_registered') {
        alertStore.setAlert('This account has already been registered. Sign in to continue.', 'info', 0)
      } else if (result.reason === 'expired') {
        alertStore.setAlert('This invite link has expired. Please contact the event organizer.', 'error', 0)
      } else {
        alertStore.setAlert('This invite link is invalid.', 'error', 0)
      }
      return navigateTo('/login')
    }
  } catch (error) {
    console.error('Error checking event invite status:', error)
  }
})
